















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AzureDataLakeChannelDetails } from '@/types';
import { v4 as uuid } from 'uuid';
import { Getter } from 'vuex-class';

@Component
export default class AzureDataLakeIntegration extends Vue {
  @Prop() private integrationDetails!: AzureDataLakeChannelDetails;
  private authType: string = 'sas';
  @Getter private hasPermission!: any;
  private readonly rules: any = {
    required: (value: string) => !!value || 'This field is required.',
  };
  private showSecret: boolean = false; // TODO: Temporary, but needs to be addressed correctly

  @Watch( 'authType' )
  private onAuthTypeChange() {
    if ( this.authType === 'sas' ) {
      this.integrationDetails.accountKey = '';
    } else if ( this.authType === 'key' ) {
      this.integrationDetails.token = '';
    }
  }

  private handleErrorChange(value: boolean) {
    this.$emit('validate', !value);
  }

  private beforeMount() {
    if (this.integrationDetails && this.integrationDetails.accountKey) {
      this.authType = 'key';
    }
  }

}
